import styled from 'styled-components';

export const Container = styled.div<{ isOpen?: boolean }>`
  border: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N300
        : props.theme.atlas.semantic.color.outline.fixed};
  border-radius: 10px;
  margin: 0px 24px 16px;
  overflow-y: auto;
  min-height: ${(props) => (props.isOpen ? '200px' : '80px')};
`;

export const Body = styled.div`
  border-top: 1px solid ${(props) => props.theme.newPalette.neutral.N300};
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
